// extracted by mini-css-extract-plugin
export default {"main":"DSIData_main__pf49u","header":"DSIData_header__zU+wn","tabs":"DSIData_tabs__vvblL","tab":"DSIData_tab__eSaSd font-sm-regular","compContainer":"DSIData_compContainer__NcjzB"};